import { oe as h, nr as p, f as c, or as a, E as d } from "./abstract-base-0be59b32-472aea73.js";
import { S as u } from "./chart-base.helpers-5f952374-c2b708da.js";
import { s as m } from "./data-item-base-2fe63b3c-0a258a70.js";
import "./unsafe-svg-7963a9ae-a1571060.js";
import "./legend-5216905c-c7014324.js";
import "./legend-circle-0e9cbc84-7a23b644.js";
import "./directive-daf4e9b6-abc0af54.js";
const b = {
  beaconTagName: "beacon-chart-tooltip-data"
}, g = h`.container{align-items:baseline;display:flex}.container.main{border-block-end:var(--beacon-chart-tooltip-override-divider-border-block-end, none);padding-block-end:var(--beacon-chart-tooltip-override-container-main-padding-block-end, 0)}.container.subset{margin-block-start:var(--beacon-chart-tooltip-override-container-subset-margin-block-start, 0)}.icon{align-items:center;display:grid;justify-content:start;margin-inline-end:var(--beacon-unit-subatomic);min-inline-size:var(--beacon-unit-base)}.icon ::slotted(svg),.icon .fallback-icon{fill:var(--icon-color, currentColor)}.label,.metric{font:var(--beacon-system-font-weight-normal, var(--beacon-font-weight-normal)) var(--beacon-system-font-size-sans-serif-caption-300, var(--beacon-caption-font-size-300)/var(--beacon-caption-font-line-height-module-300) var(--beacon-font-family-default))}.label{padding-block-start:var(--beacon-chart-tooltip-override-label-padding-block-start, 0)}.metric{font-weight:var(--beacon-font-weight-bold);margin-inline-start:var(--beacon-unit-atomic);padding-block-start:var(--beacon-chart-tooltip-override-metric-padding-block-start, 0)}:host([subset]) .icon{padding-inline-start:3px}:host([subset]) .icon ::slotted(svg),:host([subset]) .icon .fallback-icon{inline-size:var(--beacon-unit-subatomic)}
`;
var f = Object.defineProperty, y = Object.getOwnPropertyDescriptor, v = (r, e, n, o) => {
  for (var t = o > 1 ? void 0 : o ? y(e, n) : e, i = r.length - 1, s; i >= 0; i--)
    (s = r[i]) && (t = (o ? s(e, n, t) : s(t)) || t);
  return o && t && f(e, n, t), t;
};
class l extends p(m) {
  constructor() {
    super(...arguments), this.beaconTagName = b.beaconTagName, this.disableIcon = !1, this.subset = !1;
  }
  static get styles() {
    return [...super.styles, g];
  }
  /** The hierarchy level of the data item. */
  get dataLevel() {
    return this.subset ? "subset" : "main";
  }
  /** The appropriate color for the icon depending on hierarchy. */
  get iconColor() {
    return this.subset ? "var(--beacon-chart-tooltip-divider-color-background)" : this.color ? this.color : `var(--beacon-chart-override-drilldown-series-color-${this.index}, var(--beacon-chart-series-color-${this.index}))`;
  }
  /** Conditionally render icon HTML. */
  renderIcon() {
    return this.disableIcon ? c : a`<div class="icon">
          <slot name="icon">${u(this.index % 5)}</slot>
        </div>`;
  }
  /** Conditionally render label HTML. */
  renderLabel() {
    return this.label ? a`<div class="label">${this.label}</div>` : c;
  }
  /** Conditionally render value HTML. */
  renderValue() {
    return this.value ? a`<div class="metric">${this.value}</div>` : c;
  }
  connectedCallback() {
    var e;
    (e = this.handleDefer()) == null || e.then(() => {
      super.connectedCallback(), this.requiredProps = ["label", "value"];
    });
  }
  render() {
    return a`<style>
        ::slotted(svg),
        .fallback-icon {
          --icon-color: ${this.iconColor};
        }
      </style>

      <div class="container ${this.dataLevel}">${this.renderIcon()} ${this.renderLabel()} ${this.renderValue()}</div>`;
  }
}
l.tagName = b.beaconTagName;
v([
  d({ attribute: "disable-icon", type: Boolean })
], l.prototype, "disableIcon", 2);
v([
  d({ type: Boolean })
], l.prototype, "subset", 2);
export {
  l as BeaconChartTooltipData
};
